import { supabase } from "@/integrations/supabase/client";

export type SsoTenant = {
  id: string;
  slug: string;
  display_name: string;
  protocol: "oidc" | "saml";
  supabase_provider: string;
  is_active: boolean;
};

/**
 * Resolve an SSO tenant for the current login host.
 * Returns null when no tenant matches — caller should fall back to password-only.
 */
export async function resolveTenantForHost(host: string): Promise<SsoTenant | null> {
  console.log("[sso] resolveTenantForHost host=", host);
  try {
    const { data, error } = await supabase.rpc("sso_resolve_tenant_by_host", { p_host: host });
    console.log("[sso] resolveTenantForHost rpc result", { data, error });
    if (error) {
      console.warn("[sso] resolveTenantForHost error", error);
      return null;
    }
    const row = Array.isArray(data) ? data[0] : data;
    console.log("[sso] resolveTenantForHost tenant row=", row);
    return row ?? null;
  } catch (e) {
    console.warn("[sso] resolveTenantForHost threw", e);
    return null;
  }
}

/**
 * Optional fallback resolver — used only if host doesn't match a tenant
 * but the typed email matches an allowed domain.
 */
export async function resolveTenantForEmail(email: string): Promise<SsoTenant | null> {
  if (!email?.includes("@")) return null;
  try {
    const { data, error } = await supabase.rpc("sso_resolve_tenant_by_email_domain", { p_email: email });
    if (error) return null;
    const row = Array.isArray(data) ? data[0] : data;
    return row ?? null;
  } catch {
    return null;
  }
}

export async function beginSsoSignIn(tenant: SsoTenant): Promise<void> {
  const redirectTo = `${window.location.origin}/auth/callback`;
  await supabase.auth.signInWithOAuth({
    provider: tenant.supabase_provider as "azure",
    options: {
      scopes: "openid email profile",
      redirectTo,
    },
  });
}
